import { Spacing } from "themes/interfaces";

export default {
  xxs: 0.5,
  xs: 1,
  sm: 1.5,
  md: 2,
  lg: 2.5,
  xl: 3,
  xxl: 4,
  xxxl: 5,
  factor: 8,
  default: 40,
} as Spacing;
